import React from 'react'
import advancesRoutes from './ARAdvance/ARAdvanceRoutes'
import arCreditNoteRoute from './ARCreditNote/ARCreditNoteRoutes'
import debitNoteRoutes from './ARDebitNote/ARDebitNoteRoutes'
import arDigitalReportRoutes from './ARDigitalReport/ARDigitalReportRoutes'
import arGLExportRoutes from './ARGLExport/ARGLExportRoutes'
import arInvoiceRoutes from './ARInvoice/ARInvoiceRoutes'
import receiptRoutes from './AROfficialReceipt/AROfficialReceiptRoutes'
import refundRoutes from './ARRefund/ARRefundRoutes'
import { ARSubmenu } from './ARSubmenu'
import debtorAccountRoutes from './DebtorAccount/DebtorAccountRoutes'
import arConsolidatedEInvoiceRoutes from './ARConsolidateEInvoice/ARConsolidateEInvoiceRoutes'
import arSceduledBillingRoutes from './ARScheduledBilling/ARScheduledBillingRoutes'
import invoiceAmortisationRoutes from './ARInvoiceAmortisation/ARInvoiceAmortisationRoute'
import arProformaInvoicesRoutes from './ARProformaInvoices/ProformaInvoicesRoutes'

const ARRoutes = [
  {
    props: { exact: true, path: '/account-receivable/:CompanyID' },
    component: <ARSubmenu accountType="account-receivable" />,
  },
  ...debtorAccountRoutes,
  ...arInvoiceRoutes,
  ...debitNoteRoutes,
  ...refundRoutes,
  ...advancesRoutes,
  ...receiptRoutes,
  ...arCreditNoteRoute,
  // ...billItemRoutes,
  ...arDigitalReportRoutes,
  ...arGLExportRoutes,
  ...arConsolidatedEInvoiceRoutes,
  ...arSceduledBillingRoutes,
  // ...creditorProfileRoutes,
  // ...creditordebtorRoutes,
  // ...generalPostingListingRoutes,
  ...invoiceAmortisationRoutes,
  ...arProformaInvoicesRoutes,
]

export default ARRoutes
